import { AccountsSlider, CardsSlider } from '@widgets/index';
import { Payments } from '@shared/widgets';

export const Dashboard = () => {
  return (
    <div className='pt-7.5 max-md:pt-6'>
      <div className='mx-auto w-full max-w-[1294px] px-5'>
        <div className='overflow-hidden'>
          <div className='mb-6.5 flex h-[20px] items-center justify-between pl-3 select-none max-md:mb-5 max-md:h-[15px] max-md:p-0 max-md:pl-2.5'>
            <div className='relative text-xl font-bold text-[#f2f2f2] uppercase before:absolute before:top-0 before:left-[-10px] before:font-semibold before:text-[#a73f33] before:content-["/"] max-md:text-sm'>
              Accounts
            </div>
          </div>
          <AccountsSlider />
        </div>
        <Payments className='pt-7.5 max-md:pt-1.5' />
        <div className='overflow-hidden pt-7.5'>
          <div className='flex h-[20px] items-center justify-between pl-3 select-none max-md:mb-5 max-md:h-[15px] max-md:p-0 max-md:pl-2.5'>
            <div className='relative text-xl font-bold text-[#f2f2f2] uppercase before:absolute before:top-0 before:left-[-10px] before:font-semibold before:text-[#a73f33] before:content-["/"] max-md:text-sm'>
              Cards
            </div>
          </div>
          <CardsSlider />
        </div>
      </div>
    </div>
  );
};
